import {
  AlertTriangle,
  Bell,
  Boxes,
  Calendar,
  CheckCircle2,
  Database,
  GitBranch,
  Home,
  type LucideIcon,
  Play,
  Settings,
  Share2,
  Sliders,
} from "lucide-react";

export interface NavItem {
  /** URL segment under the project; "" is Home. */
  id: string;
  label: string;
  icon: LucideIcon;
  section?: "project";
  /** Screens that are not bound to an environment hide the scope pill. */
  environmentBound: boolean;
}

export const projectNav: NavItem[] = [
  { id: "", label: "Home", icon: Home, environmentBound: true },
  { id: "runs", label: "Runs", icon: Play, environmentBound: true },
  { id: "jobs", label: "Jobs", icon: Calendar, environmentBound: true },
  { id: "models", label: "Models", icon: Boxes, environmentBound: true },
  { id: "tests", label: "Tests", icon: CheckCircle2, environmentBound: true },
  { id: "lineage", label: "Lineage", icon: Share2, environmentBound: true },
  { id: "sources", label: "Sources", icon: Database, environmentBound: true },
  { id: "issues", label: "Issues", icon: AlertTriangle, environmentBound: true },
  {
    id: "repository",
    label: "Repository",
    icon: GitBranch,
    section: "project",
    environmentBound: false,
  },
  {
    id: "environments",
    label: "Environments",
    icon: Sliders,
    section: "project",
    environmentBound: false,
  },
  { id: "alerts", label: "Alert rules", icon: Bell, section: "project", environmentBound: false },
  {
    id: "settings",
    label: "Settings",
    icon: Settings,
    section: "project",
    environmentBound: false,
  },
];
